module.exports = __webpack_public_path__ + "media/images/logo/carrefour-92e6a27c9fbdb7405269aaa6fead8d44.png";